import React, { Component } from 'react';
import { IconButton } from '@fluentui/react';
import { connect } from 'react-redux'

import { showToast } from '../../actions'

class Toast extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isActive: false,
            toast: {}
        };
    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.showToast !== this.props.showToast) {
            this.setState({
                isActive: nextProps.showToast.show,
                toast: nextProps.showToast
            }, () => {
                    if (nextProps.showToast.show) {
                        setTimeout(() => {
                            this.props.dispatch(showToast({ show: false, message: "" }))
                        }, 5000);
                    }
            });
        }
    }

    close = () => {
        this.setState({isActive:false})
    }

    render() {
        const { isActive, toast } = this.state;
        const typeClass = toast.type ? ` ${toast.type}` : "";
        return (
            <div className={(isActive ? "snackbar show" : "snackbar") + typeClass}>
                {toast.message}
                <IconButton styles={{ icon: { color: '#fff !important' }, rootHovered: { backgroundColor:'#ffffff42'} }} onClick={()=>this.close() } iconProps={{ iconName: 'Cancel' }} />
            </div>
        )
    };
}

const mapStateToProps = state => ({
    showToast: state.rootReducer.showToast,
});

export default connect(mapStateToProps)(Toast);